module.exports = __webpack_public_path__ + "img/Pablo_Cesar@2x.d9efd1f7.png";